<template>
    <div class="word_5" ref="huiyuan" style="padding-bottom: 50px">
        <div class="a4">
            <h1 style="font-size: 30px;font-weight: 600;">入  会  申  请  表</h1>
            <p style="font-size: 24px;line-height:40px;text-align:right;">{{ alldata.created_at }}</p>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:50px">单位名称</div>
                <div class="box justify-center" style="width:580px;height:50px">{{ alldata.unitname }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:80px;border-bottom:none;">法人代表</div>
                <div class="box justify-center" style="width:150px;height:80px;border-bottom:none;">企业成立时间</div>
                <div class="box justify-center" style="width:150px;height:80px;border-bottom:none;">企业性质</div>
                <div class="box justify-center" style="width:140px;height:80px;border-bottom:none;">职员人数</div>
                <div class="box justify-center" style="width:143px;height:80px;border-bottom:none;">联系人</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:80px">{{ alldata.isuploadisshow }}</div>
                <div class="box justify-center" style="width:150px;height:80px">{{ alldata.isout }}</div>
                <div class="box justify-center" style="width:150px;height:80px">{{ alldata.Tick }}</div>
                <div class="box justify-center" style="width:140px;height:80px">{{ alldata.category }}</div>
                <div class="box justify-center" style="width:143px;height:80px">{{ alldata.Contactname }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">文化程度</div>
                <div class="box justify-center" style="width:220px;height:60px">{{ alldata.Subordination }}</div>
                <div class="box justify-center" style="width:141px;height:60px">职称</div>
                <div class="box justify-center" style="width:221px;height:60px">{{ alldata.corporatename }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:340px;height:60px">统一社会信用代码</div>
                <div class="box justify-center" style="width:380px;height:60px">{{ alldata.creditcode }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">联系人电话</div>
                <div class="box justify-center" style="width:200px;height:60px">{{ alldata.phone }}</div>
                <div class="box justify-center" style="width:141px;height:60px">身份证号</div>
                <div class="box justify-center" style="width:241px;height:60px">{{ alldata.IDnumber }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:50px">单位地址</div>
                <div class="box justify-center" style="width:580px;height:50px">{{ alldata.Unitaddress }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">单位电话</div>
                <div class="box justify-center" style="width:200px;height:60px">{{ alldata.Officetelephone }}</div>
                <div class="box justify-center" style="width:181px;height:60px">邮箱</div>
                <div class="box justify-center" style="width:201px;height:60px">{{ alldata.qq }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:170px">企<br/>业<br/>概<br/>况</div>
                <div class="box justify-start" style="width:380px;height:170px;padding:10px;text-align:left;overflow:auto;">
                    {{ alldata.personincharge }}
                </div>
                <div class="box justify-start" style="width:201px;height:170px;border:none;">
                    <div class="box justify-center" style="width:201px;height:50px;border-top:none;">申请单位签章</div>
                    <div class="box" style="width:201px;height:120px;border-top:none;"></div>
                </div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:150px">协会<br/>理事会<br/>意见</div>
                <div class="box justify-start" style="width:580px;height:150px;padding:10px">
                </div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:150px">备注</div>
                <div class="box justify-start" style="width:580px;height:150px;padding:10px">
                    协会会员应遵守贵州省燃气协会章程，积极参加协会组织的各项活动，为加速我省燃气事业的发展贡献力量。
                </div>
            </div>
            <p style="text-align:start">联系电话：0851-85817948<br/>
                通讯地址：贵州省贵阳市云岩区中华中路178号706室<br/>
                邮编：550001</p>
        </div>
        <div class="botview">
            <div class="a3">
                <div class="th" style="padding: 0 60px">
                    <div class="box justify-center" style="width: 146px; height: 240px">
                        盖章的入会申请表
                    </div>
                    <div class="box justify-center" style="width: 146px; height: 240px;border-left:0;">
                        营业执照
                    </div>
                </div>
                <div class="th" style="padding: 0 60px">
                    <div class="box justify-center" style="width: 146px; height: 240px">
                        <a target="_blank" v-if="alldata.Businesslicense5.length>0" :href="alldata.Businesslicense5[0].url">有</a>
                    </div>
                    <div class="box justify-center" style="width: 146px; height: 240px;border-left:0;">
                        <a target="_blank" v-if="alldata.business_license_url != ''" :href="alldata.business_license_url">有</a>
                    </div>
                </div>
                <div v-if="otherFiles" class="th" style="padding: 0 60px">
                    <h4 style="text-align:start;margin:10px 0">补充材料：</h4>
                </div>
                <div v-for="(item,index) in otherFiles" class="th" style="padding: 0 60px">
                    <div class="box justify-center" style="width: 730px; height: 40px;text-align: center;">
                        <a v-if="alldata.Businesslicense1.length>0" :href="'http://www.gzsjzyxh.cn'+item" target="_blank">{{"文件"+(index+1)}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '../word/pdfview.less'

export default {
    props: {
        alldata: {
            type: Object,
        },
        otherFiles:{
            type:Array,
        }
    },
    data() {
        return {
            mdStyle: {},
            pdfandimg: [],
            loadingTask: "",
            numPages: null,
            url: "",
        };
    },
    mounted() {
        console.log('this.alldata', this.alldata);
        this.$emit("huangguoshu", this.$refs.huiyuan); //整页DOM上传至父组件
    },
    methods: {
        fn() {
        },
    },
};
</script>

<style lang="less" scoped>
</style>
